<template>
  <div class="wrap">
    <div class="header">
      <h3 class="title">我的作业</h3>
      <div class="search-box">
        <div v-if="keyword !== ''" class="kecheng_souan" @click="handleSearch">搜索</div>
        <img class="kecheng_sst" src="../images/kcsoutp.png" />
        <el-input class="kecheng_sousuo" placeholder="搜索课程名称" @input="handleSearchls" v-model="keyword">
          <!-- <i slot="suffix" class="el-icon-search" @click="handleSearch"></i> -->
        </el-input>
      </div>
    </div>
    <div class="course-content">
      <div class="kecheng_xhhz" v-for="(item, index) in sykecheng" :key="index">
        <div style="display: flex;flex: 1;">
          <div class="kecheng_left">
            <img class="kecheng_left" :src="item.course_cover" alt="">
            <div v-if="item.unread_count >= 1" class="kecheng_wds">{{ item.unread_count }}</div>
          </div>
          <div class="kecheng_nr">
            <div class="kecheng_kcmc">{{item.course_name}}</div>
            <div class="kecheng_bq">班期：{{item.class_name}}</div>
            <div class="kecheng_dzys">待完成作业数：<span style="color: #FF7D00; font-weight: 500;">{{item.uncompleted_tasks}}</span></div>
          </div>
        </div>
        <div class="kecheng_ckxq" @click="toHomeworkDetailPage(item)">查看详情</div>
      </div>
      <!-- <table class="table">
        <tr class="table-header">
          <th class="left-headr">课程信息</th>
          <th>班期名称</th>
          <th class="left-headr">章节名称</th>
          <th>待完成作业数</th>
          <th>操作</th>
        </tr>
        <tr v-for="item of homeworkList" :key="item.id">
          <td>{{item.course_name}}</td>
          <td>{{item.class_name}}</td>
          <td>{{item.chapter_id?item.chapter_name:item.section_name}}</td>
          <td :style="item.count>=1?'color:#FF571F;':''">{{item.count}}</td>
          <td style="color:#1872ED; font-size:12px;cursor:pointer" @click="toHomeworkDetailPage(item)">     
            <span>作业明细</span>
            <span v-show="item.read_status==1" class="red-dot"></span>
          </td>
        </tr>
      </table> -->
    </div>
    <div class="pagination">
      <el-pagination background :page-size="5"  @current-change="handleCurrentChange"  layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keyword:'',
      pagination: {
        page: 1,
        total: 0,
        num: 6,
      },
      homeworkList:[],
      total:0,
      page: 1,
      sykecheng: []
    }
  },
  created() {
    // this.getHomeworkList()
    this.homeworkListByClass()
  },

  methods: {
    handleSearchls() {
      if (this.keyword === '') {
        this.handleSearch()
      }
    },
    homeworkListByClass(){
      const data = {
        page:this.page,
        page_nums:5
      }
      if(this.keyword){
        data.keyword = this.keyword
      }
      this.$tenghuiApi.post('/onlineapi/user/index/homeworkListByClass', data).then(res=>{
        console.log('[<-- 课程列表 -->]',res);
        if (res.data.code==200) {
          console.log('sss111111111=====', res.data.data.count)
          this.sykecheng = res.data.data.list
          this.total = res.data.data.count
        }    
      })  
    },
    getCourseHomeworkRead(){
      this.$tenghuiApi.post('/onlineapi/user/index/getCourseRead').then(res=>{
        console.log('[<-- res作业未读数 -->]',res);
        if (res.data.code==200) {
          this.unreadCount=res.data.data
        }    
      })  
    },
    async getHomeworkList(){
      const data = {
        page:this.page,
        page_nums:10
      }
      if(this.keyword){
        data.keyword = this.keyword
      }
      const res = await this.$tenghuiApi.post('/onlineapi/user/index/taskList',data)
      if(res.data.code == 200 ){
        console.log('res作业列表',res);
        this.homeworkList = res.data.data.list
        this.total = res.data.data.count
      }
    },
    handleCurrentChange(val) {
      this.page = val
      this.homeworkListByClass()
    },
    handleSearch(){
      this.page = 1 
      this.homeworkListByClass()
    },
    // async toDetail(item){
    //     const data={
    //       course_id:item.course_id,
    //       chapter_id:item.chapter_id,
    //       section_id:item.section_id
    //     }
    //     const res=await this.$tenghuiApi.post('/onlineapi/user/index/courseRead',data)
    //     console.log('[<-- res点击红点 -->]',res);
    // },
   async toHomeworkDetailPage(item){
      // await this.toDetail(item)
      await this.getCourseHomeworkRead()
      this.$emit('changePage',{page:'HomeworkDetail',query:item})
    }
  },
}
</script>

<style lang="scss" scoped>
li,
ul,
p,
h4 {
  margin: 0;
  padding: 0;
  list-style: none;
}
th{
  font-weight: normal;
}
.wrap {
  background: #ffffff;
  margin: 24px 0px 24px 24px;
  padding: 20px 0 20px 30px;
  max-height: 753px;
  overflow-y: auto;
  box-sizing: border-box;
  .header{
    padding-bottom: 17px;
    padding-right: 30px;
    box-sizing: border-box;
    border-bottom: 1px solid #e8eaec;
    display: flex;
    align-items: center;
    .search-box{
      // width: 180px;
      margin-left: auto;
      position: relative;
      ::v-deep .el-input__inner{
        border: none;
        background: #F7F7F7;
        border-radius:8px;
        padding-left: 36px;
        height: 32px;
      }
      ::v-deep .el-input__suffix{
        color: #1872ed;
      }
      ::v-deep .el-input__suffix{
        top: 9px;
        right: 10px;
        cursor: pointer;
      }
      .kecheng_souan {
        width: 90px;
        height: 32px;
        background: #286bff;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-400;
        font-weight: 400;
        color: #ffffff;
        position: absolute;
        z-index: 1;
        margin-left: 315px;
        border-radius: 0 8px 8px 0;
      }
      .kecheng_sst {
        width: 20px;
        height: 20px;
        position: absolute;
        margin-left: 28px;
        margin-top: 6px;
        z-index: 1;
      }
      .kecheng_sousuo {
        width: 390px;
        height: 32px;
        background: #f4f6f6;
        border-radius: 8px;
        margin-left: 16px;
      }
    }
  }
}
.title {
  font-size: 20px;
  color: #202020;
}
.red-dot {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: red;
  border-radius: 50%; 
  margin-left: 5px;
}
/* 整个滚动条 */
::-webkit-scrollbar {
  width: 4px;
  height: 12px !important;
}
 
/* 滚动条上的滚动滑块 */
::-webkit-scrollbar-thumb {
    background-color: #e3e8e9; /* 滑块颜色 */
    border-radius: 6px; /* 滑块圆角 */
    // background: #e3e8e9; /* 滑块边框 */
}
.course-content {
  margin-top: 16px;
  // padding: 0px 20px 0 30px;
  box-sizing: border-box;
  font-size: 14px;
  max-height: calc(753px - 90px - 32px - 20px - 17px - 16px - 24px);
  overflow-y: auto;
  padding-right: 30px;
  .kecheng_xhhz {
    display: flex;
    justify-content: space-between;
    margin-bottom: 34px;
    .kecheng_ckxq {
      width: 90px;
      height: 32px;
      background: #286bff;
      border-radius: 8px;
      text-align: center;
      line-height: 32px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      color: #ffffff;
      margin-top: 70px;
      cursor: pointer;
    }
    .kecheng_nr {
      margin-left: 12px;
      .kecheng_dzys {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-400;
        font-weight: 400;
        color: #909399;
        margin-top: 22px;
      }
      .kecheng_bq {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-400;
        font-weight: 400;
        color: #848586;
        margin-top: 12px;
      }
      .kecheng_kcmc {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-500;
        font-weight: 500;
        color: #202020;
      }
    }
    .kecheng_left {
      width: 180px;
      height: 100px;
      border-radius: 8px;
      position: relative;
      .kecheng_wds {
        min-width: 13px;
        height: 17px;
        background: #f53f3f;
        border: 1px solid #ffffff;
        border-radius: 100px;
        position: absolute;
        margin-top: -105px;
        text-align: center;
        line-height: 17px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-400;
        font-weight: 400;
        color: #ffffff;
        padding: 0 2px;
      }
    }
  }
  .table{
    width: 100%;
    border: 1px solid #e8eaec;
    border-collapse:collapse;
  }
  tr{
      width: 100%;
      display: grid;
      grid-template-columns: 2fr 1fr 2fr 1fr 1fr;
      justify-content: center;
      align-items: center;
      min-height: 50px;
      th{
        border-right: 1px solid #e8eaec;
        height: 100%;
        line-height: 50px;
        border-bottom: 1px solid #e8eaec;

      }
      th:last-child{
        border-right: none;
      }
      td{
        border-right: 1px solid #e8eaec;
        border-bottom: 1px solid #e8eaec;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }
      td:last-child{
        border-right: none;
      }
  }
  tr:first-child th{
    border-bottom: none;
  }
  tr:last-child td{
    border-bottom: none;
  }
  .table-header{
      background: #F5F6F7;
      color: #808695;
      .left-headr{
        // text-align: left;
        // padding-left: 20px;
      }
  }
}
.pagination {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 20px;
}
.pagination >>> .el-pager li:not(.disabled).active {
  background: #1872ed;
}


</style>
